import { render, staticRenderFns } from "./ItemPost.vue?vue&type=template&id=67e818ec&"
import script from "./ItemPost.vue?vue&type=script&lang=js&"
export * from "./ItemPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports